import { createLogger } from "@uuip/unified-ui-platform-sdk";
export const logger = createLogger("agentx-component-stores");
